import React from 'react';
import { Sparkline } from '../common/Sparkline';
import { SectionLink } from './SectionLink';
import { answerRateTone, formatDuration, formatNumber, formatPercent, initials } from '../../utils/format';
import { teamLabel, teamTone as circle } from '../../utils/teams';
import type { TeamSummary } from '../CallsInsightHub/useCallsInsightHub';
interface TeamPerformanceProps {
  summaries: TeamSummary[];
  onViewAll: () => void;
}
export function TeamPerformance({
  summaries,
  onViewAll
}: TeamPerformanceProps) {
  return <section aria-labelledby="team-perf-heading" className="flex h-full flex-col rounded-2xl border border-line bg-surface p-6 shadow-card" data-id="element-322" data-mp="ev8l2hg77dur">
      <div className="mb-4 flex items-start justify-between gap-3" data-id="element-323" data-mp="oupr4zzd3tr9">
        <h2 id="team-perf-heading" className="text-base font-semibold text-ink" data-id="element-324" data-mp="oty6ulb7tiga">
          Team performance
        </h2>
        <SectionLink label="View report" onClick={onViewAll} data-id="element-325" data-mp="2lpcesydsh00b" />
      </div>
      <div className="-mx-2 overflow-x-auto" data-id="element-326" data-mp="2qmmauwvoo9x4">
        <table className="w-full min-w-[400px] text-sm" data-id="element-327" data-mp="2coqva09mhgvz">
          <thead data-id="element-328" data-mp="2cqbptpvxsztu">
            <tr className="text-xs text-muted" data-id="element-329" data-mp="2cqv8x9xbpu9g">
              <th scope="col" className="px-2 pb-2 text-left font-medium" data-id="element-330" data-mp="27x92w0lo0omm">Team</th>
              <th scope="col" className="px-2 pb-2 text-right font-medium" data-id="element-331" data-mp="22ypdtrbrywq1">Talk time</th>
              <th scope="col" className="px-2 pb-2 text-right font-medium" data-id="element-332" data-mp="1yxvpwxyc1hx5">Calls made</th>
              <th scope="col" className="px-2 pb-2 text-right font-medium" data-id="element-333" data-mp="2vnwh13m6cahm">Answer rate</th>
              <th scope="col" className="px-2 pb-2 text-right font-medium" data-id="element-334" data-mp="2qos6o9nik6pp">Trend</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-line" data-id="element-335" data-mp="2mmosveddgq19">
            {summaries.map(({
            team,
            stats,
            series,
            trend
          }) => <tr key={team} data-id="element-336" data-mp="2hn2365gcxhbk">
                <td className="px-2 py-3.5" data-id="element-337" data-mp="2hnu0pltilp4h">
                  <div className="flex items-center gap-2.5" data-id="element-338" data-mp="1b7rn2ssyxm77">
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[11px] font-bold ${circle[team]}`} data-id="element-339" data-mp="1b5yg1ceg0zyo">
                      {initials(teamLabel(team))}
                    </span>
                    <span className="whitespace-nowrap font-semibold text-ink" data-id="element-340" data-mp="1cp6tnztf1xxo">{teamLabel(team)}</span>
                  </div>
                </td>
                <td className="px-2 py-3.5 text-right font-bold text-ink" data-id="element-341" data-mp="yonp52o5ta09">{formatDuration(stats.talkSeconds)}</td>
                <td className="px-2 py-3.5 text-right text-ink" data-id="element-342" data-mp="12pg0c1gldoz6">{formatNumber(stats.outbound)}</td>
                <td className={`px-2 py-3.5 text-right font-semibold ${answerRateTone(stats.answerRate)}`} data-id="element-343" data-mp="oy1hpvqljpsn">{formatPercent(stats.answerRate)}</td>
                <td className="px-2 py-3.5" data-id="element-344" data-mp="f1q14tjz4dse">
                  <div className="flex justify-end" data-id="element-345" data-mp="f2rgha80vmfx">
                    <Sparkline data={series} tone={trend >= 0 ? 'positive' : 'danger'} width={64} height={22} data-id="element-346" data-mp="k09omye7txmv" />
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </section>;
}